// extracted by mini-css-extract-plugin
module.exports = {"button":"LightButton_button__23k5S","enabled":"LightButton_enabled__1RfXf"};